module.exports = __webpack_public_path__ + "static/media/top-img_10.a4728589.png";